import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DiagStackGenericResponse } from '../../../projects/client';

import { DiagStackDtcActions } from './diag-stack-dtc.actions';
import { ActiveDtc } from './diag-stack-dtc.model';
import { DiagStackDtcSelectors } from './diag-stack-dtc.selectors';

@Injectable({ providedIn: 'root' })
export class DiagStackDtcStore {
  isActiveDtcLoading$: Observable<boolean> = this.store.select(
    DiagStackDtcSelectors.isActiveDtcLoading
  );

  activeDtcResponse$: Observable<DiagStackGenericResponse> = this.store.select(
    DiagStackDtcSelectors.getActiveDtcResponse
  );

  getActiveDtcForSelectedError$: Observable<ActiveDtc> = this.store.select(
    DiagStackDtcSelectors.getActiveDtcForSelectedError
  );

  getAllActiveDtcLogicalLink$: Observable<string> = this.store.select(
    DiagStackDtcSelectors.getAllActiveDtcLogicalLink
  );

  activeDtcList$: Observable<ActiveDtc[]> = this.store.select(
    DiagStackDtcSelectors.getAllActiveDtc
  );

  getActiveDtc(gatewaySerial: string): void {
    this.store.dispatch(DiagStackDtcActions.getActiveDtc.attempt({ gatewaySerial }));
  }

  constructor(private store: Store) {}
}
